import { SET_COOKIE_ACK, SET_COOKIE_GROUPS } from 'framework/vuex/mutation-types';

/**
 * Set a range of allowed cookies
 *
 * @param {function } commit
 * @param {string[]} groups
 */
export function setAllowedGroups({ commit }, { groups }) {
    commit(SET_COOKIE_GROUPS, { groups });
}

export function setCookieAck({ commit }, { ack }) {
    commit(SET_COOKIE_ACK, { ack });
}
